import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import IMG1 from "../../../images/industries/healthcare/telemedicine.png";
import IMG2 from "../../../images/industries/healthcare/Cloud-Based-Hosting.png";
import IMG3 from "../../../images/industries/healthcare/Mobile-First.png";
import IMG4 from "../../../images/industries/healthcare/Enterprise-Ready.png";
import IMG5 from "../../../images/industries/healthcare/BYOD.png";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Demandfeatures1(props) {
  const [toggleState, setToggleState] = useState(0);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  const getActiveClass = (index, className) =>
    toggleState === index ? className : "";
  return (
    <section className="tekrevol_gray_bg p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <div className="example" data-text="Streamlining">
              <h2>
                Streamlining Digital Healthcare Operations With Modernized
                Integration Solutions
              </h2>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              Industry leaders are turning to TekRevol - the trusted partner
              that has delivered continued success since its inception. Our
              comprehensive digital healthcare integration solutions enable you
              to navigate the complexities of Healthcare technology, so you can
              focus on providing the best possible patient care.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={2} lg={2} xl={2} xxl={2}>
            <div
              className={`industries_boxes hover01 ${getActiveClass(
                0,
                "active-tabs"
              )}`}
              onClick={() => toggleTab(0)}
            >
              <LazyLoadImage
                src={IMG1}
                effect="blur"
                className="img-fluid"
                alt="TELEMEDICINE App"
              />
              <h6>TELEMEDICINE</h6>
            </div>
          </Col>
          <Col xs={12} md={2} lg={2} xl={2} xxl={2}>
            <div
              className={`industries_boxes hover01 ${getActiveClass(
                1,
                "active-tabs"
              )}`}
              onClick={() => toggleTab(1)}
            >
              <LazyLoadImage
                src={IMG2}
                effect="blur"
                className="img-fluid"
                alt="cloud-based hosting solutions "
              />
              <h6>CLOUD BASED </h6>
            </div>
          </Col>
          <Col xs={12} md={2} lg={2} xl={2} xxl={2}>
            <div
              className={`industries_boxes hover01 ${getActiveClass(
                2,
                "active-tabs"
              )}`}
              onClick={() => toggleTab(2)}
            >
              <LazyLoadImage
                src={IMG3}
                effect="blur"
                className="img-fluid"
                alt="MOBILE-FIRST"
              />
              <h6>MOBILE-FIRST </h6>
            </div>
          </Col>
          <Col xs={12} md={2} lg={2} xl={2} xxl={2}>
            <div
              className={`industries_boxes hover01 ${getActiveClass(
                3,
                "active-tabs"
              )}`}
              onClick={() => toggleTab(3)}
            >
              <LazyLoadImage
                src={IMG4}
                effect="blur"
                className="img-fluid"
                alt="enterprise-ready solutions"
              />
              <h6>ENTERPRISE READY </h6>
            </div>
          </Col>
          <Col xs={12} md={2} lg={2} xl={2} xxl={2}>
            <div
              className={`industries_boxes hover01 ${getActiveClass(
                4,
                "active-tabs"
              )}`}
              onClick={() => toggleTab(4)}
            >
              <LazyLoadImage
                src={IMG5}
                effect="blur"
                className="img-fluid"
                lt="BYOD-based enterprise mobility solutions"
              />
              <h6>BYOD BASED </h6>
            </div>
          </Col>

          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            {/*<p className={toggleState === 0 ? 'industries_content d-block' : "content d-none"}*/}
            {/*>At TekRevol, we believe that everyone deserves access to quality healthcare. Our telemedicine solutions enable healthcare professionals worldwide to deliver real-time health and clinical services to patients, regardless of their physical locations. Our secure and reliable technology streamlines operations, allowing healthcare professionals to focus on providing excellent care to the patient globally.</p>*/}
            <p
              className={
                toggleState === 0
                  ? "industries_content d-block"
                  : "content d-none"
              }
            >
              We believe that everyone deserves access to quality healthcare by
              offering top-tier health strategies and solutions. Our
              telemedicine solutions enable healthcare professionals worldwide
              to deliver real-time health and clinical services to patients,
              regardless of their physical locations. Our secure and reliable
              services streamline operations, allowing healthcare professionals
              to focus on providing excellent care to patients globally.
              <div className="btn_talk sol-btn">
                <Link
                  to="/contact"
                  className="border_btn"
                  aria-label="TekRevol Contact"
                >
                  Let’s Connect!
                </Link>
              </div>
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            {/*<p className={toggleState === 1 ? 'industries_content d-block' : "content d-none"}*/}
            {/*>TekRevol's HIPAA compliant cloud-based hosting solutions provide enhanced security, scalability, and innovation for healthcare operations. Our hosting solutions are tailored to meet the unique needs of healthcare providers, ensuring seamless and secure data management while enabling growth and innovation. With our cloud-based hosting solutions, you can rest assured that your data is safe and accessible.*/}
            {/*</p>*/}
            <p
              className={
                toggleState === 1
                  ? "industries_content d-block"
                  : "content d-none"
              }
            >
              Our HIPAA-compliant cloud-based hosting solutions provide enhanced
              security, scalability, and innovation for healthcare operations.
              It is because our healthcare digital solutions are precisely
              customized to meet the unique needs of healthcare providers.
              That’s how we ensure fluent and secure data management while
              enabling growth and innovation. With our cloud-based hosting
              solutions, you can rest assured that your data is safe and
              accessible.
              <div className="btn_talk sol-btn">
                <Link
                  to="/contact"
                  className="border_btn"
                  aria-label="TekRevol Contact"
                >
                  Let’s Connect!
                </Link>
              </div>
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <p
              className={
                toggleState === 2
                  ? "industries_content d-block"
                  : "content d-none"
              }
            >
              Healthcare professionals need to stay mobile while delivering
              quality care to patients. We've got you covered with our
              cutting-edge healthcare mobility solution. Our mobile-first
              healthcare solution empowers you to support your clinical
              workforce remotely with optimal efficiency. With our secure and
              HIPAA-HITECH-compliant solutions for health, you can streamline
              PHI exchange and ensure seamless collaboration among your team.
              <div className="btn_talk sol-btn">
                <Link
                  to="/contact"
                  className="border_btn"
                  aria-label="TekRevol Contact"
                >
                  Let’s Connect!
                </Link>
              </div>
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <p
              className={
                toggleState === 3
                  ? "industries_content d-block"
                  : "content d-none"
              }
            >
              Transform your digital health operations with our enterprise-ready
              solutions, crafted to improve patient outcomes, optimize
              workflows, and drive innovation. Our customized solutions cater to
              the unique needs of hospitals, clinics, and all healthcare
              providers, helping you to achieve your goals resulting in
              exceptional care. So, you can count on our unwavering support
              every step of the way.
              <div className="btn_talk sol-btn">
                <Link
                  to="/contact"
                  className="border_btn"
                  aria-label="TekRevol Contact"
                >
                  Let’s Connect!
                </Link>
              </div>
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <p
              className={
                toggleState === 4
                  ? "industries_content d-block"
                  : "content d-none"
              }
            >
              Maximize the potential of your clinical workforce with our
              BYOD-based enterprise mobility solutions. We offer secure access
              to critical patient data from any device at any time. Our
              expertise in the latest technology and experience ensure that
              patient data remains safe and secure while giving your workforce
              the flexibility they need to deliver quality care. We are
              committed to providing innovative solutions that cater to the
              unique needs of healthcare providers.
              <div className="btn_talk sol-btn">
                <Link
                  to="/contact"
                  className="border_btn"
                  aria-label="TekRevol Contact"
                >
                  Let’s Build Your Health App!
                </Link>
              </div>
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Demandfeatures1;
